import createEnum from 'scripts/lib/create_enum';

const FeatureNotificationTypes = createEnum('IN_APP_NOTIFICATION');
export default FeatureNotificationTypes;
